import { BLOCKED_EXTENSIONS } from './constants';

export function getFileExtension(filename) {
  if (!filename || !filename.includes('.')) return '';
  return filename.split('.').pop().toLowerCase();
}

export function isBlockedFile(file) {
  const ext = getFileExtension(file.name);
  return ext && BLOCKED_EXTENSIONS.has(ext);
}
